import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Nav from "./Components/Nav/Nav";
import Home from "./Pages/Home";
import About from "./Pages/About/About";
import Gallery from "./Pages/Gallery/Gallery";
import Footer from "./Components/Footer/Footer";
import Panels from "./Pages/Panels/Panels";
import Contact from "./Pages/Contact/Contact";
import Admission from "./Pages/Admission/Admission";
import DevDet from "./Pages/DevDet/DevDet";

function App() {
  return (
    <Router>
      <div className="App">
        <Nav />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/about" component={About} />
          <Route exact path="/gallery" component={Gallery} />
          <Route exact path="/login" component={Panels} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/admission" component={Admission} />
          <Route exact path="/dev" component={DevDet} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
